<mat-form-field class="app-select" [floatLabel]="asFormsControl().floatingLabelNever ? 'never': 'always'">
    <mat-select
        #select
        panelClass="app-select-panel"
        disableOptionCentering
        [placeholder]="asFormsControl().placeholder"
        [disabled]="asFormsControl().disabled"
        [multiple]="asFormsControl().multiple"
        (selectionChange)="changeValue($event)"
        (openedChange)="onTouched && onTouched()">
        <mat-option
            *ngFor="let option of asFormsControl().options"
            [value]="option.value"
            [disabled]="option.disabled">
            {{option.label}}
        </mat-option>

        <div class="dynamic-input" [formGroup]="inputForm" *ngIf="asFormsControl().isDynamic">
            <mat-form-field appearance="outline">
                <mat-label>+ Define new</mat-label>
                <input type="text" formControlName="inputTxt" matInput/>
            </mat-form-field>
            <div class="row no-gutters pb-1">
                <div class="col-sm-6 text-right pr-2">
                    <button type="button" class="btn btn-primary" (click)="handleCreateNewItemClick()">Create</button>
                </div>
            </div>
        </div>

    </mat-select>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>
